import { ChevronDownIcon } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@artstorefronts/ui';
import { SUGGESTION_GROUPS } from './constants';
import { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function Suggestions({
  onSuggestionClick,
  disabled,
}: {
  onSuggestionClick: (prompt: string) => void;
  disabled: boolean;
}) {
  const { t } = useTranslation('chat');
  const containerRef = useRef<HTMLDivElement>(null);
  const [showLabels, setShowLabels] = useState(true);

  useEffect(() => {
    const checkContainerWidth = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        setShowLabels(width >= 694);
      }
    };

    checkContainerWidth();
    window.addEventListener('resize', checkContainerWidth);

    return () => window.removeEventListener('resize', checkContainerWidth);
  }, []);

  return (
    <div className="pt-3" ref={containerRef}>
      <div className="flex flex-wrap justify-center gap-2">
        {SUGGESTION_GROUPS.map((group, groupIndex) => {
          const IconComponent = group.icon;
          return (
            <DropdownMenu key={groupIndex}>
              <DropdownMenuTrigger asChild disabled={disabled}>
                <button
                  className={`flex items-center gap-1 md:gap-2 px-3 py-2 bg-white hover:bg-gray-50 border rounded-full text-[13px] font-light text-gray-700 transition-colors focus:outline-hidden focus:ring-0 active:outline-hidden ${
                    disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                  }`}
                  style={{ outline: 'none', boxShadow: 'none' }}
                >
                  <IconComponent className={`w-4 h-4 ${group.iconColor}`} />
                  {showLabels && <span>{t(group.labelKey, group.label)}</span>}
                  <span>
                    <ChevronDownIcon className="w-4 h-4 text-gray-500" />
                  </span>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="center" className="w-64">
                {group.options.map((option, optionIndex) => (
                  <DropdownMenuItem
                    key={optionIndex}
                    onClick={() => onSuggestionClick(option.prompt)}
                    className="cursor-pointer px-3 py-2"
                  >
                    {t(option.titleKey, option.title)}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          );
        })}
      </div>
    </div>
  );
}

export default Suggestions;
